<template>
  <div>
    <navComponent @showlogin="upEmit"/>
  </div>
</template>

<script>
  const dirName = process.env.siteName === 'yongligao' || process.env.siteName === 'taiyangcheng018' || process.env.siteName === 'veniceman' || process.env.siteName === 'betl' || process.env.siteName === 'b027site' || process.env.siteName === 'b027sport' ? process.env.siteName : 'common'
  const navComponent = () => import('@/components/different/' + dirName + '/nav/nav')
  export default {
    components: {
      navComponent
    },
    methods: {
      upEmit () {
        this.$emit('showlogin', true)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?00df54c2